import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogIn, Shield, Globe } from "lucide-react";

export default function Login() {
  const { user } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) nav(location.state?.redirect || "/browse");
  }, [user, nav, location.state]);

  const handleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="pbp-section py-16 md:py-24 max-w-5xl">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#86868b] font-semibold">Sign in</div>
          <h1 className="mt-2 text-4xl md:text-5xl font-semibold tracking-tighter leading-tight">
            Welcome to<br />PartByPart.
          </h1>
          <p className="mt-4 text-[#1d1d1f]/75 leading-relaxed">
            Sign in with Google to list parts, message sellers, and keep track of conversations.
            One click. No passwords.
          </p>
          <button
            data-testid="login-google-btn"
            onClick={handleSignIn}
            className="mt-8 pbp-btn-primary px-6 py-3 text-base"
          >
            <LogIn className="w-4 h-4" strokeWidth={1.8} /> Continue with Google
          </button>
          <div className="mt-6 text-xs text-[#86868b] max-w-sm">
            By continuing you agree to our <a className="pbp-link" href="/terms">Terms</a> and
            <a className="pbp-link ml-1" href="/privacy">Privacy Policy</a>.
          </div>
        </div>

        <div className="space-y-4">
          <div className="pbp-card p-5 flex gap-4">
            <div className="w-10 h-10 rounded-xl bg-[#0071e3]/10 grid place-items-center text-[#0071e3]"><Shield className="w-5 h-5" strokeWidth={1.6} /></div>
            <div><div className="font-semibold">Safer conversations</div><div className="text-sm text-[#86868b]">Verified sessions, persistent safety banners, and a one-tap report button.</div></div>
          </div>
          <div className="pbp-card p-5 flex gap-4">
            <div className="w-10 h-10 rounded-xl bg-[#34c759]/10 grid place-items-center text-[#34c759]"><Globe className="w-5 h-5" strokeWidth={1.6} /></div>
            <div><div className="font-semibold">Truly global</div><div className="text-sm text-[#86868b]">Listings default to your country and local currency, with worldwide search.</div></div>
          </div>
        </div>
      </div>
    </div>
  );
}
